import React from "react";

const QmsQuestionEntrySheet = ({
  drafts,
  errorsById = {},
  isEditMode = false,
  readOnly = false,
  onAddDraft,
  onRemoveDraft,
  onUpdateDraft,
}) => (
  <div
    className={`qms-q-sheet${readOnly ? " is-readonly" : ""}`}
    data-tour="qms-question-form-sheet"
  >
    <div className="qms-q-sheet__head">
      <div className="qms-q-sheet__head-question">Question</div>
      <div className="qms-q-sheet__head-options">
        Options
        <span className="qms-q-sheet__head-hint">select one correct</span>
      </div>
    </div>

    {drafts.map((draft, index) => {
      const errors = errorsById[draft.id] || {};
      const optionError = errors.options || errors.correct;
      const showRemove = !readOnly && !isEditMode && drafts.length > 1;

      return (
        <div key={draft.id} className="qms-q-sheet__row">
          {showRemove && (
            <button
              type="button"
              className="qms-q-sheet__remove"
              onClick={() => onRemoveDraft(draft.id)}
              aria-label={`Remove question ${index + 1}`}
            >
              ×
            </button>
          )}

          <div
            className="qms-q-sheet__question"
            data-tour={index === 0 ? "qms-question-form-question" : undefined}
          >
            <div className="qms-q-sheet__field qms-q-sheet__field--question">
              <textarea
                className="qms-q-sheet__textarea"
                placeholder={index === 0 ? "Enter question text" : `Question ${index + 1}`}
                value={draft.questionText}
                readOnly={readOnly}
                disabled={readOnly}
                onChange={(e) =>
                  onUpdateDraft(draft.id, (d) => ({ ...d, questionText: e.target.value }))
                }
              />
            </div>
            {errors.questionText && (
              <div className="qms-q-sheet__inline-error">{errors.questionText}</div>
            )}
          </div>

          <div
            className="qms-q-sheet__options-wrap"
            data-tour={index === 0 ? "qms-question-form-options" : undefined}
          >
            <div className="qms-q-sheet__field qms-q-sheet__field--options">
              <div className="qms-q-sheet__options">
              {draft.options.map((opt, optIdx) => (
                <label key={optIdx} className="qms-q-sheet__option">
                  <input
                    type="radio"
                    name={`correct-${draft.id}`}
                    checked={!!opt.IsCorrect}
                    disabled={readOnly}
                    onChange={() =>
                      onUpdateDraft(draft.id, (d) => ({
                        ...d,
                        options: d.options.map((o, i) => ({
                          ...o,
                          IsCorrect: i === optIdx,
                        })),
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="qms-q-sheet__option-input"
                    placeholder={`Option ${optIdx + 1}`}
                    value={opt.OptionText}
                    readOnly={readOnly}
                    disabled={readOnly}
                    onChange={(e) =>
                      onUpdateDraft(draft.id, (d) => ({
                        ...d,
                        options: d.options.map((o, i) =>
                          i === optIdx ? { ...o, OptionText: e.target.value } : o,
                        ),
                      }))
                    }
                  />
                </label>
              ))}
              </div>
            </div>
            {optionError && (
              <div className="qms-q-sheet__inline-error">{optionError}</div>
            )}
          </div>
        </div>
      );
    })}

    {!readOnly && !isEditMode && (
      <button
        type="button"
        className="qms-q-sheet__add"
        data-tour="qms-question-form-add-row"
        onClick={onAddDraft}
      >
        <i className="fas fa-plus" aria-hidden="true" />
        Add question
      </button>
    )}
  </div>
);

export default QmsQuestionEntrySheet;
